module.exports = {
	/**
	 * @type {string}
	 * @description 首页背景视频，放在 public 目录下可直接用 /video/xxx.mp4
	 */
	heroVideo: '/video/header.mp4',
	/**
	 * @type {string}
	 * @description 视频加载失败或未启用时的封面图
	 */
	heroPoster: '/img/header/poster.jpg',
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: '/img/header/poster.jpg',
	bg2: '/img/header/poster.jpg',
	bg3: '/img/header/poster.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'HT Blog'
}
